import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Spin,
  Select,
  DatePicker,
  Checkbox,
  Form,
  Input,
  Button,
  Table,
  Image,
  notification,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getGenderCategory,
  getGenderCategoryChange,
} from "../../redux/actions/genderCategory.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getProductClass } from "../../redux/actions/productClass.action";
import { getFitCategory } from "../../redux/actions/fitCategory.action";
import { getProductType } from "../../redux/actions/productType.action";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import { getSize } from "../../redux/actions/size.action";
import { getSku } from "../../redux/actions/sku.action";
import { ReadCookie } from "../../utils/readCookie";
import { getWashName } from "../../redux/actions/wash.action";
import { getStyle } from "../../redux/actions/style";
import moment from "moment";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo.png";
import "../Distributor/Distributor.css";
import { Link, useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { TabTitle } from "../../utils/GeneralFunction";
import { getSeasonYear } from "../../redux/actions/seasonYear.action";
import { getAdminLocation } from "../../redux/actions/adminLocation.action";
import { getOpOts } from "../../redux/actions/skuLookupData.action";
import axios from "axios";
import { saveAs } from "file-saver";
import { BASEURL } from "../../constant/config";
import { allSizesOpOts, createNestedColumn, kidsSizesOpOts, menSizesOpOts, womenSizesOpOts } from "../../utils/sizeChart";


const dateFormatList = ["MM-DD-YYYY"];

const OPOts = ({ token }) => {
  TabTitle("OP OTS");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    style,
    gender,
    genderCategory,
    season,
    wash,
    opOtsData,
    genderCategoryChange,
    styleChange,
    Sku,
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const tableRef = useRef(null);
  const [isGenerate, setIsGenerate] = useState("All");
  const [isSKU, setIsSKU] = useState("All");



  const { Option } = Select;


  const onFinish = async (e) => {
    await form.setFieldsValue({
      gender_id: isGenerate,
      sku: isSKU
    });
    await form.validateFields().then((values) => {
      const distributorParam = {
        sku: isSKU === "All" ? null : isSKU,
        inseam: null,
        style_name: values.style_id === "All" ? null : values.style_id,
        wash_name: values.wash_id === "All" ? null : values.wash_id,
        current_season: values.season_id === "All" ? null : values.season_id,
        gender_name: isGenerate === "All" ? null : isGenerate,
        fit_category_name: null,
        product_status_id: null,
      };
      setLoading(true);
      dispatch(getOpOts(token, distributorParam)).then((res) => {
        setLoading(false);
        setData(res?.payload?.data);
        // downloadExcelFileData(res?.payload?.data);
      });
    });
  };

  console.log("opOtsData", opOtsData)

  const notificationKey = `open${Date.now()}`;
  const load = <div className="d-flex"><span className="spin-color mx-2">
    <Spin size="small" />
  </span><p>Please wait for a few minutes</p></div>;

  const handleDownload = async () => {
    try {
      // form.setFields("gender_id",isGenerate)
      notification.open({
        message: "Preparing Excel Download...",
        description: load,
        key: notificationKey,
        duration: 0,
      });

      await form.setFieldsValue({
        gender_id: isGenerate,
        sku: isSKU
      });
      await form.validateFields().then(async (values) => {

        const distributorParam = {
          season_id: values.season_id === "All" ? null : values.season_id,
          sku: isSKU === "All" ? null : isSKU,
          gender_category_id: values.type === "All" ? null : values.type,

          style_id: values.style_id === "All" ? null : values.style_id,
          pending_date: moment(values.as_on_date).format("YYYY-MM-DD"),
          as_on_date: moment(values.as_on_date).format("YYYY-MM-DD"),
          category_id:
            values.gender_category_id === "All"
              ? null
              : values.gender_category_id,
          fit_category_id: null,
          gender_id: isGenerate === "All" ? null : isGenerate,
          product_class_id: null,
          sort_on: null,
          include_bgrade: "abc",
          wash_id: values.wash_id === "All" ? null : values.wash_id,
          new_sesaon_year_id:
            values.new_season_year_id === "All"
              ? null
              : values.new_season_year_id,
        };
        const key = "immediate_ots"
        const response = await axios.post(`${BASEURL}getAll/DownloadSkuLookupData`, { distributorParam, key }, {
          responseType: "blob", // Important!
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const blob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "OP-OTS.xlsx");

        notification.destroy({ key: notificationKey });
        notification.success({
          message: "Download Successful",
          description: "Your Excel report has been downloaded.",
          className: "toast-success",
        });
      });
    } catch (error) {
      console.error("Download failed", error);

      // Destroy loader and show error notification
      notification.destroy({ key: notificationKey });
      notification.error({
        message: "Download Failed",
        description: "Something went wrong while downloading the Excel report.",
        className: "toast-error",
      });
    }
  };


  useEffect(() => {
    dispatch(getStyle(token, menuId));
    dispatch(getGenderCategory(token, menuId));
    dispatch(getSeason(token, menuId));
    dispatch(getProductStatus(token, menuId));
    dispatch(getProductClass(token, menuId));
    dispatch(getSize(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getFitCategory(token, menuId));
    dispatch(getWashName(token, menuId));
    dispatch(getSeasonYear(token, menuId));
    dispatch(getAdminLocation(token, menuId));
  }, [dispatch, menuId, token]);


  const handlePrint = () => {
    window.print();
  };


  // const handleGender = (gender_id) => {
  //   console.log("abc",gender_id)
  //   setIsGenerate(gender_id)
  //   // form.setFieldsValue({
  //   //   gender_category_id: "All",
  //   //   style_id: "All",
  //   //   sku: "All",
  //   // });
  // };

  // const handleStyle = (gender_category_id) => {
  //   form.setFieldsValue({
  //     style_id: "All",
  //     sku: "All",
  //   });
  // };

  // const handleSku = (sku_id) => {
  //   if (sku_id === null) {
  //     dispatch(getSku(token, null, null, null));
  //   } else {
  //   }
  //   form.setFieldsValue({
  //     sku: "All",
  //   });
  // };

  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleSkuSearch = () => {
    dispatch(getSku(token, null, null, null));
  };

  const optimizedFn = useCallback(debounce(handleSkuSearch), []);


  const isRestrictedSize = (gender, size) => {
    return (
      (gender === "Men" && size === "28") ||
      (gender === "Women" && (size === "23" || size === "23P")) ||
      size === "XS" ||
      (gender === "Kids" && (size === "7" || size === "8" || size === "S"))
    );
  };

  const getQtyValueByKey = (data, qtyKey) => {
    const size = data?.all_locations?.size_1;
    const gender = data?.gender_name;

    let suffix = parseInt(qtyKey.split("_").pop());  // qty_3 -> 3

    // Special shift logic
    if (size === "7") {
      suffix = suffix - 6;
    } else if (size === "8") {
      suffix = suffix - 7;
    } else if (size === "S") {
      suffix = suffix - 2; // qty_3 -> qty_1, qty_4 -> qty_2, etc.
    }

    // Restricted logic
    const isRestricted = isRestrictedSize(gender, size);
    if (!["7", "8", "S"].includes(size) && isRestricted) {
      if (suffix === 1) return 0;
      suffix = suffix - 1;
    }

    const baseQtyKey = `qty_${suffix}`;
    const baseQty = Number(data?.all_locations[baseQtyKey]) || 0;

    const additionalSources = [
      `ecommerce_qty_${suffix}`,
      `nord_qty_${suffix}`,
      `verishop_qty_${suffix}`,
      `neiman_qty_${suffix}`,
      `saks_qty_${suffix}`,
      `moda_qty_${suffix}`,
      `macys_qty_${suffix}`,
      `anthro_qty_${suffix}`
    ];

    const additionalQty = additionalSources.reduce((total, key) => {
      return total + (Number(data?.all_locations[key]) || 0);
    }, 0);

    return baseQty + additionalQty;
  };


  const generateSizeColumns = (sizesArray, prefix) => {
    return sizesArray.map(({ titles, border, width }, index) => {
      const key = `${prefix}_${index + 1}`;

      return createNestedColumn(
        titles,
        key,
        width || 50,
        {
          className: border ? "border-right" : "",
          render: (text, data) => {
            return getQtyValueByKey(data, key);
          },
        }
      );
    });
  };


  const getQtyValueByKeyPK = (data, qtyKey) => {
    const size = data?.all_locations?.size_1;
    const gender = data?.gender_name;

    let suffix = parseInt(qtyKey.split("_").pop());  // qty_3 -> 3

    // Special shift logic
    if (size === "7") {
      if (suffix === 8) return 0; // <-- 7X index fixed as 0
      if (suffix > 8) suffix = suffix - 1; // shift remaining sizes
      suffix = suffix - 6;
    } else if (size === "8") {
      // suffix = suffix - 7; //previous condition valid for without 7X size
      suffix = suffix - 8;
    } else if (size === "S") {
      suffix = suffix - 2;
    }

    // Restricted logic
    const isRestricted = isRestrictedSize(gender, size);
    if (!["7", "8", "S"].includes(size) && isRestricted) {
      if (suffix === 1) return 0;
      suffix = suffix - 1;
    }

    const baseQtyKey = `qty_${suffix}`;
    const baseQty = Number(data?.all_locations_pk[baseQtyKey]) || 0;

    return baseQty;
  };

  const generateSizeColumnsPk = (sizesArray, prefix) => {
    return sizesArray.map(({ titles, border, width }, index) => {
      const key = `${prefix}_${index + 1}`;

      return createNestedColumn(
        titles,
        key,
        width || 50,
        {
          className: border ? "border-right" : "",
          render: (text, data) => {
            return getQtyValueByKeyPK(data, key);
          },
        }
      );
    });
  };

  const getQtyValueByKeyTotal = (data, qtyKey) => {
    const otsQty = getQtyValueByKey(data, qtyKey) || 0;
    const pkQty = getQtyValueByKeyPK(data, qtyKey) || 0;

    return otsQty + pkQty;
  };

  const generateSizeColumnsTotal = (sizesArray, prefix) => {
    return sizesArray.map(({ titles, border, width }, index) => {
      const key = `${prefix}_${index + 1}`;

      return createNestedColumn(
        titles,
        key,
        width || 50,
        {
          className: border ? "border-right" : "",
          render: (text, data) => {
            return getQtyValueByKeyTotal(data, key);
          },
        }
      );
    });
  };

  let sizeChartRendering = form.getFieldValue("gender_id")
  let sizeChartRenderingSKU = form.getFieldValue("sku")



  const colums = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: 40,
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "Image",
      dataIndex: "image_url",
      key: "image_url",
      width: 30,
      render: (text, record) => (
        <div className="image-nu">
          <Image src={text} />
        </div>
      ),
    },
    {
      title: "Orignal Season",
      dataIndex: "original_season",
      key: "original_season",
      sorter: (a, b) => {
        if ((a.original_season !== null) && (b.original_season !== null)) {
          return a.original_season.localeCompare(b.original_season);
        }
      },
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      render: (text, record) => {
        return (
          <Link
            style={{
              color: "blue",
              textDecoration: "underline",
            }}
            to={{
              pathname: `/sku-lookup?sku=${record.sku}`,
              state: data,
            }}
            target="_blank"
          >
            {record.sku}
          </Link>
        );
      },
      sorter: (a, b) => {
        return a.sku - b.sku;
      },
    },
    {
      title: "Inseam",
      dataIndex: "inseam",
      key: "inseam",
      sorter: (a, b) => {
        return a.inseam - b.inseam;
      },
    },
    {
      title: "Fit Category",
      dataIndex: "fit_category_name",
      key: "fit_category_name",
      sorter: (a, b) => {
        if ((a.fit_category_name !== null) && (b.fit_category_name !== null)) {
          return a.fit_category_name.localeCompare(b.fit_category_name);
        }
      },
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      sorter: (a, b) => {
        if ((a.style_name !== null) && (b.style_name !== null)) {
          return a.style_name.localeCompare(b.style_name);
        }
      },
    },
    {
      title: "Wash",
      dataIndex: "wash_name",
      key: "wash_name",
      sorter: (a, b) => {
        if ((a.wash_name !== null) && (b.wash_name !== null)) {
          return a.wash_name.localeCompare(b.wash_name);
        }
      },
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      sorter: (a, b) => {
        if ((a.gender_name !== null) && (b.gender_name !== null)) {
          return a.gender_name.localeCompare(b.gender_name);
        }
      },
    },
    {
      title: "Fabric",
      dataIndex: "fabric_name",
      key: "fabric_name",
      sorter: (a, b) => {
        if ((a.fabric_name !== null) && (b.fabric_name !== null)) {
          return a.fabric_name.localeCompare(b.fabric_name);
        }
      },
    },
    {
      title: "WS",
      dataIndex: "ws",
      key: "ws",
      align: "right",
      sorter: (a, b) => {
        return a.ws - b.ws;
      },
    },
    {
      title: "RTL",
      dataIndex: "rtl",
      key: "rtl",
      align: "right",
      sorter: (a, b) => {
        return a.rtl - b.rtl;
      },
    },
    {
      title: "1st Size",
      align: "center",
      render: (text, record,) => {
        return (
          record?.all_locations?.size_1
        );
      },
      sorter: (a, b) => {
        if ((a.all_locations?.size_1 !== null) && (b.all_locations?.size_1 !== null)) {
          return a.all_locations?.size_1.localeCompare(b.all_locations?.size_1);
        }
      },
    },
    //for Kids
    sizeChartRendering === "Kids" || (sizeChartRenderingSKU !== "All" && opOtsData?.payload?.data?.[0]?.gender_name === "Kids") ? (
      {
        children: generateSizeColumns(kidsSizesOpOts, "qty")
      }
    )
      : sizeChartRendering === "Women" || (sizeChartRenderingSKU !== "All" && opOtsData?.payload?.data?.[0]?.gender_name === "Women") ? (
        // // for Women
        {
          children: generateSizeColumns(womenSizesOpOts, "qty")
        }
      )
        : sizeChartRendering === "Men" || (sizeChartRenderingSKU !== "All" && opOtsData?.payload?.data?.[0]?.gender_name === "Men") ? (

          // for Men
          {
            children: generateSizeColumns(menSizesOpOts, "qty")
          }) :

          ///for All
          {
            children: generateSizeColumns(allSizesOpOts, "qty")
          },
    {
      title: (
        <>
          BERGEN OTS <br />
          (IMMEDIATE w/ECOM/D2C)
        </>
      ),
      align: "center",
      className: "border-z-index-1",
      render: (text, record,) => {
        return (
          (Number(record?.all_locations?.ots) || 0) +
          (Number(record?.all_locations?.ecommerce) || 0) +
          (Number(record?.all_locations?.nord) || 0) +
          (Number(record?.all_locations?.verishop) || 0) +
          (Number(record?.all_locations?.neiman) || 0) +
          (Number(record?.all_locations?.saks) || 0) +
          (Number(record?.all_locations?.moda) || 0) +
          (Number(record?.all_locations?.macys) || 0) +
          (Number(record?.all_locations?.anthro) || 0)
        );
      },
      sorter: (a, b) => {
        const aTotal =
          (Number(a?.all_locations?.ots) || 0) +
          (Number(a?.all_locations?.ecommerce) || 0) +
          (Number(a?.all_locations?.nord) || 0) +
          (Number(a?.all_locations?.verishop) || 0) +
          (Number(a?.all_locations?.neiman) || 0) +
          (Number(a?.all_locations?.saks) || 0) +
          (Number(a?.all_locations?.moda) || 0) +
          (Number(a?.all_locations?.macys) || 0) +
          (Number(a?.all_locations?.anthro) || 0);

        const bTotal =
          (Number(b?.all_locations?.ots) || 0) +
          (Number(b?.all_locations?.ecommerce) || 0) +
          (Number(b?.all_locations?.nord) || 0) +
          (Number(b?.all_locations?.verishop) || 0) +
          (Number(b?.all_locations?.neiman) || 0) +
          (Number(b?.all_locations?.saks) || 0) +
          (Number(b?.all_locations?.moda) || 0) +
          (Number(b?.all_locations?.macys) || 0) +
          (Number(b?.all_locations?.anthro) || 0);

        return aTotal - bTotal;
      },
      border: true
    },
    //for Kids
    sizeChartRendering === "Kids" || (sizeChartRenderingSKU !== "All" && opOtsData?.payload?.data?.[0]?.gender_name === "Kids") ? (
      {
        children: generateSizeColumnsPk(kidsSizesOpOts, "qty")
      }
    )
      : sizeChartRendering === "Women" || (sizeChartRenderingSKU !== "All" && opOtsData?.payload?.data?.[0]?.gender_name === "Women") ? (
        // // for Women
        {
          children: generateSizeColumnsPk(womenSizesOpOts, "qty")
        }
      )
        : sizeChartRendering === "Men" || (sizeChartRenderingSKU !== "All" && opOtsData?.payload?.data?.[0]?.gender_name === "Men") ? (

          // for Men
          {
            children: generateSizeColumnsPk(menSizesOpOts, "qty")
          }) :

          ///for All
          {
            children: generateSizeColumnsPk(allSizesOpOts, "qty")
          },
    {
      title: "PK ONLY (SEA)",
      align: "center",
      className: "border-z-index-1",
      // border: true,  
      render: (text, record,) => {
        return (
          (Number(record?.all_locations_pk?.ots) || 0)
        );
      },
      sorter: (a, b) => {
        return (
          (Number(a?.all_locations_pk?.ots) || 0) -
          (Number(b?.all_locations_pk?.ots) || 0)
        );
      },
    },
    //for Kids
    sizeChartRendering === "Kids" || (sizeChartRenderingSKU !== "All" && opOtsData?.payload?.data?.[0]?.gender_name === "Kids") ? (
      {
        children: generateSizeColumnsTotal(kidsSizesOpOts, "qty")
      }
    )
      : sizeChartRendering === "Women" || (sizeChartRenderingSKU !== "All" && opOtsData?.payload?.data?.[0]?.gender_name === "Women") ? (
        // // for Women
        {
          children: generateSizeColumnsTotal(womenSizesOpOts, "qty")
        }
      )
        : sizeChartRendering === "Men" || (sizeChartRenderingSKU !== "All" && opOtsData?.payload?.data?.[0]?.gender_name === "Men") ? (

          // for Men
          {
            children: generateSizeColumnsTotal(menSizesOpOts, "qty")
          }) :

          ///for All
          {
            children: generateSizeColumnsTotal(allSizesOpOts, "qty")
          },
    {
      title: "GRAND TOTAL",
      align: "center",
      className: "border-z-index-1",
      render: (text, record) => {
        return (
          (Number(record?.all_locations?.ots) || 0) +
          (Number(record?.all_locations?.ecommerce) || 0) +
          (Number(record?.all_locations?.nord) || 0) +
          (Number(record?.all_locations?.verishop) || 0) +
          (Number(record?.all_locations?.neiman) || 0) +
          (Number(record?.all_locations?.saks) || 0) +
          (Number(record?.all_locations?.moda) || 0) +
          (Number(record?.all_locations?.macys) || 0) +
          (Number(record?.all_locations?.anthro) || 0) +
          (Number(record?.all_locations_pk?.ots) || 0)
        );
      },
      sorter: (a, b) => {
        const aTotal =
          (Number(a?.all_locations?.ots) || 0) +
          (Number(a?.all_locations?.ecommerce) || 0) +
          (Number(a?.all_locations?.nord) || 0) +
          (Number(a?.all_locations?.verishop) || 0) +
          (Number(a?.all_locations?.neiman) || 0) +
          (Number(a?.all_locations?.saks) || 0) +
          (Number(a?.all_locations?.moda) || 0) +
          (Number(a?.all_locations?.macys) || 0) +
          (Number(a?.all_locations?.anthro) || 0) +
          (Number(a?.all_locations_pk?.ots) || 0);

        const bTotal =
          (Number(b?.all_locations?.ots) || 0) +
          (Number(b?.all_locations?.ecommerce) || 0) +
          (Number(b?.all_locations?.nord) || 0) +
          (Number(b?.all_locations?.verishop) || 0) +
          (Number(b?.all_locations?.neiman) || 0) +
          (Number(b?.all_locations?.saks) || 0) +
          (Number(b?.all_locations?.moda) || 0) +
          (Number(b?.all_locations?.macys) || 0) +
          (Number(b?.all_locations?.anthro) || 0) +
          (Number(b?.all_locations_pk?.ots) || 0);

        return aTotal - bTotal;
      },
    },
    {
      title: "SKU Inseam",
      dataIndex: "sku_inseam",
      key: "sku_inseam",
      border: true,
      sorter: (a, b) => {
        if ((a.sku_inseam !== null) && (b.sku_inseam !== null)) {
          return a.sku_inseam.localeCompare(b.sku_inseam);
        }
      },
    },
    {
      title: "Current Season",
      dataIndex: "current_season",
      key: "current_season",
      border: true,
      sorter: (a, b) => {
        if ((a.current_season !== null) && (b.current_season !== null)) {
          return a.current_season.localeCompare(b.current_season);
        }
      },
    },
  ];

  return (
    <div className="header_class business_header_oms">
      <div className="row justify-content-between business_class_oms distributor">
        <div className="col-3 d-flex align-items-start box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8">
              <div className="print_icon printing_class">
                <i
                  onClick={handlePrint}
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div className="print_icon printing_class" onClick={handleDownload}>
                {/* <CSVLink
                  filename={"Imediate-OTS-By-Size.csv"}
                  data={excelData}
                  onClick={downloadExcelFileData}
                  style={{ display: "flex" }}
                > */}
                <input
                  type="image"
                  name="ImgExcel"
                  alt="Export to excel"
                  id="ImgExcel"
                  title="Export to excel"
                  src={xlsx}
                  height={14}
                />
                {/* </CSVLink> */}
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              OP OTS
              <br />
              Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p>
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
            </span>
          </div>
        </div>
      </div>

      <div className="business_class_oms mb-2 distributor">
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className="col-12">
              <hr className="my-1" />
              <div className="main_form row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Gender
                    </label>
                    <div className="w-100">
                      {/* <Form.Item name="gender_id" initialValue={"All"}> */}
                      <Select
                        className={"select_Inputs"}
                        showSearch
                        optionFilterProp="children"
                        size="small"
                        defaultValue={"All"}
                        // onChange={(e) => handleGender(e)}
                        onChange={(e) => {
                          console.log("eeeeeeeeeee", e);
                          setIsGenerate(e);
                        }}
                      >
                        <Option value={null}>All</Option>
                        {gender &&
                          gender?.payload?.data.map((it, index) => {
                            return (
                              <Option key={index} value={it.gender_name}>
                                {it.gender_name}
                              </Option>
                            );
                          })}
                      </Select>
                      {/* </Form.Item> */}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Season
                    </label>
                    <div className=" w-100">
                      <Form.Item name="season_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().season_name}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {season &&
                            season?.payload?.data?.map((status, index) => {
                              return (
                                <Option key={index} value={status.season_name}>
                                  {status.season_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">

                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Wash
                    </label>
                    <div className="w-100">
                      <Form.Item name="wash_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().wash_name}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {wash &&
                            wash?.payload?.data?.map((status, index) => {
                              return (
                                <Option key={index} value={status.wash_name}>
                                  {status.wash_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/*Second*/}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Category
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="gender_category_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          // onChange={(e) => handleStyle(e)}

                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {genderCategoryChange &&
                            genderCategoryChange?.payload?.data.length >= 0
                            ? genderCategoryChange &&
                            genderCategoryChange?.payload?.data.map(
                              (it, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={it.gender_category_name}
                                  >
                                    {it.gender_category_name}
                                  </Option>
                                );
                              }
                            )
                            : genderCategory &&
                            genderCategory?.payload?.data.map((it, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={it.gender_category_name}
                                >
                                  {it.gender_category_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
              <div className="main_form row form-margin">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Sku
                    </label>
                    <div className="w-100">
                      {/* <Form.Item name="sku" initialValue={"All"}> */}
                      <Select
                        notFoundContent={
                          Sku.loading ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Loader
                                type="Oval"
                                color="#3c4b58"
                                height={20}
                                width={20}
                              />
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                              }}
                            >
                              No Data
                            </div>
                          )
                        }
                        className={"select_Inputs"}
                        showSearch
                        onSearch={(value) => {
                          optimizedFn(value);
                        }}
                        onChange={(e) => {
                          console.log("eeeeeeeeeee", e);
                          setIsSKU(e);
                        }}
                        defaultValue={"All"}
                        optionFilterProp="children"
                        size="small"
                      >
                        <Option value="All">All</Option>
                        {Sku &&
                          Sku?.payload?.data.map((it, index) => {
                            return (
                              <Option key={index} value={it.sku}>
                                {it.sku}
                              </Option>
                            );
                          })}
                      </Select>
                      {/* </Form.Item> */}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Style
                    </label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="style_id">
                        <Select
                          className={"select_Inputs"}
                          showSearch

                          optionFilterProp="children"
                          size="small"
                          // onChange={(e) => handleSku(e)}
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null ?
                              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                          }
                        >
                          <Option value={null}>All</Option>
                          {styleChange && styleChange?.payload?.data.length >= 0
                            ? styleChange &&
                            styleChange?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_name}>
                                  {style.style_name}
                                </Option>
                              );
                            })
                            : style &&
                            style?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_name}>
                                  {style.style_name}
                                </Option>
                              );
                            })}

                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "3px",
                      float: "right",
                    }}
                  >
                    <Button
                      style={{ width: "fit-content" }}
                      type="primary"
                      htmlType="submit"
                      className="submit-btn-btm m-0"
                    >
                      Generate
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div >
        <div
          className="overflow"
          style={{
            overflowY: "scroll",
          }}
        >
          {opOtsData?.payload?.data !== undefined ? (
            opOtsData?.payload?.data.length > 0 ? (
              <Table
                className="border-line-th  bottom-align-th  table-td-border-right  th-general-style  
              td-general-style even-tr-style border omsTable"
                style={{ fontSize: "9px" }}
                ref={tableRef}
                size="small"
                bordered={false}
                type="company"
                headerClassName="abc"
                dataSource={data || []}
                columns={colums}
                loading={opOtsData.loading}
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: 50,
                  pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000],
                }}
                scroll={{ x: "max-content" }}
              // summary={(pageData) => {
              //   let Quantity = pageData.reduce(function (
              //     previousValue,
              //     currentValue
              //   ) {
              //     return (previousValue += parseFloat(
              //       currentValue.sum_quantity
              //     ));
              //   },
              //     0);
              //   return (
              //     <>
              //       <Table.Summary.Row>
              //         {/* <Table.Summary.Cell colSpan={2}>Total Quantity : {numeral(totalQuantity()).format("0,00,0")}
              //         </Table.Summary.Cell> */}
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell>
              //         {/* <Table.Summary.Cell></Table.Summary.Cell>
              //         <Table.Summary.Cell></Table.Summary.Cell> */}
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             Total :
              //           </p>{" "}
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {bergotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {trnsTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {pkTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {prodTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {pendTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {intTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p
              //             style={{ textAlign: "right" }}
              //             className="totalquantity"
              //           >
              //             {otsTotal.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //       </Table.Summary.Row>
              //     </>
              //   );
              // }}
              />
            ) : (
              <div className="no-Data">
                <h1>No Data</h1>
              </div>
            )
          ) : (
            loading && (
              <div className="loader" style={{ marginTop: "20px" }}>
                <Spin size="medium" />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default OPOts;
